import ScorecardCalculatedParametersTable from './ScorecardCalculatedParametersTable';

export default ScorecardCalculatedParametersTable;


// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/scorecard-calculated-parameters-table/index.js